import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';

import SelectInput from '../../inputs/SelectInput';

import { BlueCloseIcon } from '../../../images/icons/WrapSvg';

class CommandPopup extends React.Component {
    state = {
        open: false,
        product: null,
        units: 0,
    };

    handleChangeProces = (event) => {
        this.setState({ product: event });
    };

    handleChangeMachine = (event) => {
        this.setState({ machine: event });
    };


    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };


    handleChangeClick = (add) => (event) => {
        const { units } = this.state;
        const value = parseInt(units.toString().concat(add), 10);
        this.setState({ units: value });
    };

    handleRemoveUnits = (event) => {
        this.setState({ units: 0 });
    }


    isOk = () => {
        const { product, units } = this.state;
        return product && units > 0;
    };

    handleSummit = () => {
        const { product, units } = this.state;
        this.props
            .addProduction({
                idLocal: this.props.id,
                idProducto: product.value,
                cantidad: units,
                estado: 4,
            })
            .then(() => this.props.handleClose('ready', false))
            .catch((error) => this.props.handleClose('ready', error.message));
    };

    render() {
        const { product, units } = this.state;
        const { handleClose, intl, tag } = this.props;
        const disabled = !this.isOk();
        return (
            <Dialog
                onClose={() => handleClose('ready', false)}
                aria-labelledby="customized-dialog-title"
                open={true}
                disableBackdropClick
                classes={{
                    paper: 'xhef_command_popup',
                }}
            >
                <div className="flex_full_column">
                    <div className="flex_auto_row xhef_waste_popup_header align_center">
                        <IconButton
                            aria-label="Close"
                            className={''}
                            onClick={() => handleClose('ready', false)}
                        >
                            <BlueCloseIcon />
                        </IconButton>
                        <div className="flex_full_row center barlowsemicondensed_bold">
                            <FormattedMessage id="xhef_popup_command_title" />
                        </div>
                    </div>
                    <div className="flex_auto_row">
                        <div className="flex_full_column padding_borders">
                            <div className="flex_auto_row align_center ">
                                <SelectInput
                                    defaultValue={product}
                                    placeHolder={intl.formatMessage({
                                        id: 'xhef_popup_waste_products_title',
                                    })}
                                    isNotSearchable
                                    options={this.props.products
                                        .filter((f) => tag === 0 || f.nomEstacion === tag)
                                        .sort((a, b) =>
                                            a.nombre.toUpperCase() < b.nombre.toUpperCase()
                                                ? -1
                                                : 1,
                                        )
                                        .map((p) => {
                                            return { label: p.nombre.toUpperCase(), value: p.id };
                                        })}
                                    onChange={this.handleChangeProces}
                                />
                            </div>
                            <div className="flex_auto_row margin_top_32 align_center">
                                <TextField
                                    required
                                    fullWidth
                                    name={'units'}
                                    id={'units'}
                                    label={intl.formatMessage({
                                        id: 'xhef_popup_waste_units_title',
                                    })}
                                    disabled={true}
                                    value={units}
                                    type="number"
                                    inputProps={{
                                        className: 'barlowcondensed_regular c_black',
                                        pattern: '[0-9]*',
                                        style: { textAlign: 'center' },
                                    }}
                                    onChange={this.handleChange}
                                    className="text_align_center"
                                />
                            </div>
                            <div className="flex_auto_row ">
                                <div className="flex_full_column">
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(0)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            0
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(1)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            1
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(2)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            2
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(3)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            3
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(4)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            4
                                                </Button>
                                    </div>
                                    <div className="flex_full_row center margin_top_32 ">
                                        <Button
                                            onClick={this.handleChangeClick(5)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            5
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(6)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            6
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(7)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            7
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(8)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            8
                                                </Button>
                                        <Button
                                            onClick={this.handleChangeClick(9)}
                                            color="primary"
                                            variant="outlined"
                                            className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6"
                                        >
                                            9
                                                </Button>
                                    </div>
                                </div>
                                <Button
                                    onClick={this.handleRemoveUnits}
                                    color="primary"
                                    variant="outlined"
                                    className="xef_calculator_button barlowsemicondensed_regular no_uppercase c_bluish margin_right_6 margin_top_32"
                                >
                                    {
                                        intl.formatMessage({
                                            id: 'remove',
                                        })
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="flex_auto_row center xhef_waste_popup_footer">
                        <Button
                            disabled={disabled}
                            variant="contained"
                            color="primary"
                            className={'flex_full_row barlow_semibold padding_borders'}
                            onClick={this.handleSummit}
                        >
                            <FormattedMessage id="xhef_popup_command_button_title" />
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }
}

CommandPopup.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(CommandPopup);



// WEBPACK FOOTER //
// ./src/components/complex/xhef/ReadyPopup.js